<div class="rfp-header">
  <u-input
    #inputTitle
    [class.new-title]="!inputTitle.model"
    [class.readonly]="assistant.readOnly"
    class="no-state inline-input"
    data-cy="input-title"
    [placeholder]="title ?? 'Untitled'"
    (onChange)="formInputChanged.next($event)"
    [model]="isNewMode || !assistant.id ? null : title"
    [readonly]="assistant.readOnly"
  ></u-input>
  <u-button
    *ngIf="assistant.experienceType === 'rfp'"
    class="fill-rfp"
    [label]="'Fill RFP'"
    [disabled]="disabledButton"
    type="secondary"
    fontIcon="answer"
    (onClick)="fillRfp()"
  ></u-button>
</div>
